import { useEffect, useState } from 'react';
import { BusinessesService } from 'service/businesses.service';

export const useBusinessIntel = (id: string) => {
  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getDetails = async (id: string) => {
      try {
        setLoading(true);
        const res = await BusinessesService.getBusinessIntel(id);
        setData(res);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    getDetails(id);
  }, [id]);

  return { data, loading };
};
